import { render, staticRenderFns } from "./TheServices.vue?vue&type=template&id=d921689e&"
import script from "./TheServices.vue?vue&type=script&lang=js&"
export * from "./TheServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports